import { IApiRequestOptions } from '@import-io/doc-sdk';
import zeusSdk from '_/utils/SDKs';

export interface IAlarmGroup {
  id: string;
  name: string;
  flowId: string;
  createdOn: string;
  runbook?: string;
}

export interface ICreateAlarmGroupDTO {
  flowId: string;
  name: string;
}

export interface IUpdateAlarmGroupDTO {
  name?: string;
  runbook?: string;
}

/**
 * Fetch all alarm groups for a flow
 */
export const requestAlarmGroups = async (flowId: string, params: IApiRequestOptions = {}): Promise<IAlarmGroup[]> => {
  const options = {
    ...params,
    queryParameters: {
      sort: 'name',
      sortDirection: 'ASC',
      ...params.queryParameters,
    },
  };
  const { items } = await zeusSdk.flows.getChildren(flowId, 'alarmgroups', options);
  return items as IAlarmGroup[];
};

/**
 * Fetch a single alarm group
 */
export const requestAlarmGroup = async (alarmGroupId: string, params: IApiRequestOptions = {}): Promise<IAlarmGroup> => {
  return (await zeusSdk.alarmGroups.get(alarmGroupId, params)) as IAlarmGroup;
};

/**
 * Create a new alarm group
 */
export const createAlarmGroupRequest = async (flowId: string, alarmGroup: ICreateAlarmGroupDTO): Promise<IAlarmGroup> => {
  return (await zeusSdk.flows.createChild(flowId, 'alarmgroups', alarmGroup)) as IAlarmGroup;
};

/**
 * Update an alarm group
 */
export const updateAlarmGroupRequest = async (alarmGroupId: string, alarmGroup: IUpdateAlarmGroupDTO): Promise<IAlarmGroup> => {
  return (await zeusSdk.alarmGroups.patch(alarmGroupId, alarmGroup)) as IAlarmGroup;
};

/**
 * Delete an alarm group
 */
export const deleteAlarmGroupRequest = async (alarmGroupId: string): Promise<void> => {
  await zeusSdk.alarmGroups.delete(alarmGroupId);
};
